import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BannerLayer from "../components/BannerLayer";

const BannerPage = () => {
  return (
    <MasterLayout>
      <BannerLayer />
    </MasterLayout>
  );
};

export default BannerPage;
